import { Trophy, ThumbsDown } from "@phosphor-icons/react";

const fmtBed = (b) => {
  if (b == null) return "—";
  const h = Math.floor(b % 24), m = Math.round((b % 1) * 60);
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
};

const ROWS = [
  { key: "bed", label: "Средний отбой", fmt: fmtBed },
  { key: "sleep_h", label: "Сон", fmt: (v) => (v != null ? `${v} ч` : "—") },
  { key: "prev_strain", label: "Нагрузка накануне", fmt: (v) => v ?? "—" },
  { key: "hrv", label: "HRV", fmt: (v) => (v != null ? `${v} мс` : "—") },
  { key: "disturbances", label: "Пробуждения", fmt: (v) => v ?? "—" },
];

export default function BestDaysCard({ bestDays }) {
  if (!bestDays) return null;
  const { best, worst, n } = bestDays;
  const bedDiff = best.bed != null && worst.bed != null ? Math.round((worst.bed - best.bed) * 60) : null;
  const sleepDiff = best.sleep_h != null && worst.sleep_h != null ? Math.round((best.sleep_h - worst.sleep_h) * 60) : null;
  return (
    <div className="glass-card p-5" data-testid="best-days-card">
      <h3 className="text-sm font-semibold mb-1">Анатомия ваших лучших дней</h3>
      <p className="text-xs text-muted-foreground mb-4">
        Сравнение топ-{n} дней по восстановлению с {n} худшими.
        {bedDiff != null && bedDiff > 15 && <> В лучшие дни вы ложились в среднем на <span className="text-[#00e676] font-semibold">{bedDiff} мин раньше</span>.</>}
        {sleepDiff != null && sleepDiff > 15 && <> И спали на <span className="text-[#00e676] font-semibold">{sleepDiff} мин дольше</span>.</>}
      </p>
      <div className="grid grid-cols-2 gap-3">
        {[{ p: best, icon: Trophy, c: "#00e676", t: `Лучшие дни · ${best.recovery}%`, tid: "best-days-best" },
          { p: worst, icon: ThumbsDown, c: "#ff3b30", t: `Худшие дни · ${worst.recovery}%`, tid: "best-days-worst" }].map(({ p, icon: Icon, c, t, tid }) => (
          <div key={t} className="rounded-md border p-3.5" style={{ borderColor: `${c}44`, background: `${c}0d` }} data-testid={tid}>
            <div className="flex items-center gap-1.5 mb-2.5">
              <Icon size={15} weight="fill" style={{ color: c }} />
              <span className="text-xs font-bold" style={{ color: c }}>{t}</span>
            </div>
            <div className="space-y-1.5">
              {ROWS.map((r) => (
                <div key={r.key} className="flex justify-between text-xs">
                  <span className="text-muted-foreground">{r.label}</span>
                  <span className="num font-semibold">{r.fmt(p[r.key])}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
